import { ProductSKUWithChainData } from 'jigsaw';
import { useArcadeStoreState } from './useArcadeStoreState';
import { RecordWithPlaintext } from '@puzzlehq/sdk';
import { getNestedStringProperty } from '@puzzlehq/types';
import { useMemo } from 'react';

const MAX_PURCHASE_COUNT = 14;

type Props = {
  sku?: ProductSKUWithChainData;
};

export const usePurchaseHelper = ({ sku }: Props) => {
  const { descendingPartRecords, partBalance } = useArcadeStoreState();

  const { functionId, programId, recordCount, partPurchaseRecords } =
    useMemo(() => {
      if (
        sku?.chainData === undefined ||
        descendingPartRecords === undefined ||
        partBalance === undefined
      ) {
        return {
          functionId: undefined,
          programId: undefined,
          recordCount: undefined,
          partPurchaseRecords: undefined,
        };
      }

      const recordCount = getRecordCountForPurchase(
        descendingPartRecords,
        partBalance,
        sku.price
      );

      if (recordCount === 'LOW' || recordCount === 'JOIN_REQUIRED') {
        return {
          functionId: undefined,
          programId: undefined,
          recordCount,
          partPurchaseRecords: undefined,
        };
      }

      const { functionId, programId } =
        sku.chainData.programFunctionIds[recordCount];

      const partPurchaseRecords = descendingPartRecords.slice(
        0,
        Number(recordCount)
      );

      return {
        functionId,
        programId,
        recordCount,
        partPurchaseRecords,
      };
    }, [JSON.stringify(sku), JSON.stringify(descendingPartRecords)]);

  return {
    functionId,
    programId,
    recordCount,
    partPurchaseRecords,
  };
};

export type RecordCount =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | 'LOW'
  | 'JOIN_REQUIRED';
const getRecordCountForPurchase = (
  descendingPartRecords: RecordWithPlaintext[],
  partBalance: number,
  price: number
): RecordCount => {
  let i = 0;
  let balance = 0;
  if (descendingPartRecords.length === 0) return 'LOW';

  const ITER_COUNT = Math.min(MAX_PURCHASE_COUNT, descendingPartRecords.length);
  for (i = 0; i < ITER_COUNT; i++) {
    const record: RecordWithPlaintext = descendingPartRecords[i];
    if (record === undefined) break;
    const record_balance =
      Number(
        getNestedStringProperty(record.data, ['amount'])?.replace(
          'u64.private',
          ''
        ) ?? 0
      ) / 1_000_000;

    balance += record_balance;
    console.log('record_balance', record_balance);
    if (balance >= price) break;
    if (i === ITER_COUNT - 1 && balance < price) {
      console.log('balance', balance);
      return partBalance >= price ? 'JOIN_REQUIRED' : 'LOW';
    }
  }

  return (i + 1).toString() as RecordCount;
};
